var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoCloud = function SvgNoCloud(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27743 13.0084C6.74827 12.7389 6.15919 12.5991 5.56014 12.5991C0.887506 12.9286 0.887506 19.7278 5.56014 20.0573H16.6327C17.9806 20.0673 19.2785 19.5681 20.267 18.6595C23.5518 15.794 21.7945 10.0331 17.4714 9.484C15.9138 0.128748 2.40511 3.68314 5.61006 12.5991",
    stroke: "currentColor",
    strokeWidth: 1.50452,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6968 3.18514L18.6968 3.18514L0.99064 20.8919C0.399704 21.4828 0.517156 22.4038 1.05693 22.9436C1.59669 23.4833 2.51768 23.6008 3.10862 23.0098L20.8148 5.30312C20.8148 5.30311 20.8148 5.30311 20.8148 5.30311C21.4057 4.71217 21.2883 3.79119 20.7485 3.25142C20.2087 2.71165 19.2878 2.5942 18.6968 3.18514Z",
    fill: "currentColor",
    stroke: "white",
    strokeWidth: 1.19811,
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoCloud);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "no-cloud.f9b7f65dbfdc372110e5eb9ed042d241.svg";